// Smart Sash Admin Panel - Lab Management Page

import React from 'react';
import { Alert, Button, PermissionGate } from '@/components/common';
import { LabTable, LabFormModal, LabDeleteModal } from '@/components/lab';
import { useLabManagement } from '@/hooks/useLabManagement';

export const LabManagement: React.FC = () => {
  const {
    labs,
    institutions,
    groups,
    pagination,
    isLoading,
    error,
    currentPage,
    pageSize,
    pageSizeOptions,
    showModal,
    modalMode,
    showDeleteModal,
    labToDelete,
    formData,
    isSaving,
    setCurrentPage,
    handlePageSizeChange,
    handleCreateClick,
    handleEditClick,
    handleDeleteClick,
    handleSubmit,
    handleDelete,
    handleInputChange,
    handleInstitutionChange,
    closeModal,
    closeDeleteModal,
    clearError,
  } = useLabManagement();

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="h3 mb-0">Lab Management</h1>
              <p className="text-muted">Manage laboratory facilities and spaces</p>
            </div>
            <PermissionGate action="lab:create">
              <Button variant="primary" icon="fas fa-plus" onClick={handleCreateClick}>
                Add Lab
              </Button>
            </PermissionGate>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="row mb-3">
          <div className="col-12">
            <Alert variant="danger" dismissible onDismiss={clearError}>
              <i className="fas fa-exclamation-circle me-2"></i>
              {error}
            </Alert>
          </div>
        </div>
      )}

      {/* Labs Table */}
      <div className="row">
        <div className="col-12">
          <LabTable
            labs={labs}
            institutions={institutions}
            pagination={pagination}
            currentPage={currentPage}
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
            isLoading={isLoading}
            onPageChange={setCurrentPage}
            onPageSizeChange={handlePageSizeChange}
            onEdit={handleEditClick}
            onDelete={handleDeleteClick}
          />
        </div>
      </div>

      {/* Create/Edit Modal */}
      <LabFormModal
        isOpen={showModal}
        mode={modalMode}
        formData={formData}
        institutions={institutions}
        groups={groups}
        isSaving={isSaving}
        onInputChange={handleInputChange}
        onInstitutionChange={handleInstitutionChange}
        onSubmit={handleSubmit}
        onClose={closeModal}
      />

      {/* Delete Confirmation Modal */}
      <LabDeleteModal
        isOpen={showDeleteModal}
        lab={labToDelete}
        isSaving={isSaving}
        onConfirm={handleDelete}
        onClose={closeDeleteModal}
      />
    </div>
  );
};

export default LabManagement;
